import { useEffect, useState } from "react";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { Bar } from "react-chartjs-2";
import { RazorNumberFormat } from "../../../../components/razor-reuse";
import { useSelector } from "react-redux";
import RootState from "../../../../redux/type";
import { getArrayOfValues } from "../../../../utils/Helper";

// Register required components for a bar chart
ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

const options = {
  responsive: true,
  maintainAspectRatio: false,
  plugins: {
    title: {
      display: false, // No chart title
    },
    legend: {
      //   display: false, // Hide legend
      position: "bottom",
    },

    datalabels: {
      display: false,
    },
  },
  scales: {
    x: {
      grid: {
        display: false, // Remove X-axis grid lines
      },
    },
    y: {
      beginAtZero: true, // Y-axis starts from 0
      grid: {
        display: false,
      },
      ticks: {
        callback: (val: number) =>
          RazorNumberFormat(val, {
            hideDecimal: true,
            hideSymbol: true,
            numberAbbreviate: true,
          }), // Format tick values dynamically
        display: true,
      },
    },
  },
};

const data = {
  labels: [],
  datasets: [
    {
      label: "Successful Transactions ",
      data: [],
      backgroundColor: "rgba(17, 156, 43, 0.7)",
      borderColor: "rgba(17, 156, 43, 1)",
      borderWidth: 1,
    },
    {
      label: "Failed Transactions",
      data: [],
      backgroundColor: "rgba(236, 20, 16, 0.7)",
      borderColor: "rgba(236, 20, 16, 1)",
      borderWidth: 1,
    },
  ],
};

interface MyComponentProps {
  datatoShow?: any;
  activeTab?: string;
}

const MultiBarChart = ({ activeTab }: MyComponentProps) => {
  const [datatoSHow, setDataToShow] = useState<any>({
    labels: [],
    datasets: [
      {
        label: "Successful Transactions ",
        data: [12, 23, 18, 14, 21, 32, 17, 19, 21, 82, 19, 45],
        backgroundColor: "rgba(17, 156, 43, 0.7)",
        borderColor: "rgba(17, 156, 43, 1)",
        borderWidth: 1,
      },
      {
        label: "Failed Transactions",
        data: [45, 38, 81, 38, 19, 25, 75, 34, 51, 64, 19, 21],
        backgroundColor: "rgba(236, 20, 16, 0.7)",
        borderColor: "rgba(236, 20, 16, 1)",
        borderWidth: 1,
      },
    ],
  });
  const { transaction_metric } = useSelector(
    (state: RootState) => state.dashboard
  );

  useEffect(() => {
    if (Object?.keys(transaction_metric)?.length > 0) {
      const val = {
        labels: getArrayOfValues(
          "label",
          transaction_metric?.transaction_activity,
          false,
          activeTab === "month"
        ),
        datasets: [
          {
            label: "Successful Transactions ",
            data: getArrayOfValues(
              "successful_transactions",
              transaction_metric?.transaction_activity,
              true
            ),
            backgroundColor: "rgba(17, 156, 43, 0.7)",
            borderColor: "rgba(17, 156, 43, 1)",
            borderWidth: 1,
          },
          {
            label: "Failed Transactions",
            data: getArrayOfValues(
              "failed_transactions",
              transaction_metric?.transaction_activity,
              true
            ),
            backgroundColor: "rgba(236, 20, 16, 0.7)",
            borderColor: "rgba(236, 20, 16, 1)",
            borderWidth: 1,
          },
        ],
      };
      setDataToShow(val);
    }
  }, [transaction_metric]);

  return (
    <Bar data={datatoSHow} options={options as any} height={100} width={100} />
  );
};

export default MultiBarChart;
